// Search
export const SEARCH_TASK_NAMES_REQUESTED = 'SEARCH_TASK_NAMES_REQUESTED';
export const SEARCH_TASK_NAMES_SUCCESS = 'SEARCH_TASK_NAMES_SUCCESS';
export const SEARCH_TASK_NAMES_ERROR = 'SEARCH_TASK_NAMES_ERROR';
